import React from "react";
import Layout from "../../layout/builders/Layout";
import ProjectBanner from "../../layout/builders/ProjectBanner";
import CustomerEnquiries from "../../layout/builders/CustomerEnquiry/CustomerEnquiries";

const CustomerEnquiry = () => {
  return (
    <div style={{ backgroundColor: "#E0E0E0" }}>
      <Layout>
        <div>
          <ProjectBanner
            title="Customer Enquiry"
            imageUrl="https://via.placeholder.com/1200x300"
          />
        </div>
        <CustomerEnquiries />
      </Layout>
    </div>
  );
};

export default CustomerEnquiry;

